"use client"

import Link from "next/link"
import cn from "classnames"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import { AnimateText } from "~/components/elements/AnimateText/AnimateText"
import { FadeIn } from "~/components/elements/FadeIn/FadeIn"
import { Asset } from "~/components/primitives/Asset/Asset"

import type { PerspectiveCardProps } from "./PerspectiveCard.interface"
import s from "./PerspectiveCard.module.scss"

gsap.registerPlugin(ScrollTrigger)

export const PerspectiveCard = ({
  title,
  slug,
  category,
  image,
  variant = "large",
}: PerspectiveCardProps) => {
  return (
    <article className={cn(s.card, s[`card--${variant}`])}>
      <Link
        href={`/perspectives/${slug}`}
        className={s.link}
        aria-label={`Read ${title}`}
      >
        <div className={s.image}>
          <Asset
            asset={image}
            imageSizes={{
              base: "100vw",
              md: variant === "large" ? "697px" : "554px",
            }}
          />
        </div>
        <div className={s.meta}>
          <FadeIn>
            <AnimateText element="span" className={s.category}>
              {category}
            </AnimateText>
          </FadeIn>

          <FadeIn>
            <AnimateText element="h3" className={s.title}>
              {title}
            </AnimateText>
          </FadeIn>
        </div>
      </Link>
    </article>
  )
}
